import React from "react";
import InputDatoProdotto from "../elementiPagina/InputDatoProdotto";
import InputDatoProdottoTextarea from "../elementiPagina/InputDatoProdottoTextarea";

function DescHTML({prodottoTemp,handleChange,datoClass,lang, datoValue}) {
        


    return (
        <div>
            <h3>Descrizione lunga in {lang}</h3>
            <InputDatoProdottoTextarea 
                            inputLabel="HTML descrizione lunga"
                            datoName={"descrizioniSuPS.descLunga."+lang}
                            datoId={"descrizioniSuPS.descLunga."+lang}
                            datoValue={datoValue}
                            datoPlaceHolder=""
                            datoOnChange={handleChange}
                            datoClass={datoClass}
                            classiTastoSblocco="dn"
                            tastoCopiaAspetto="dn"
                        />
        </div>
    )



}

export default DescHTML;